import React from 'react';
import { UtilityBar } from '../UtilityBar';
import { SiteHeader } from '../SiteHeader/SiteHeader';
import { SiteFooter } from '../SiteFooter';
export function PageShell({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen w-full bg-paper font-sans text-ink" data-id="element-209" data-mp="2pt0pjxej5f3n">
    <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:bg-ink focus:px-4 focus:py-3 focus:text-paper" data-id="element-210" data-mp="2lr5psxc8z9rz">Skip to content</a>
    <UtilityBar data-id="element-211" data-mp="3dhtpe4y9w73j" /><SiteHeader data-id="element-212" data-mp="3di3ja3mfuyei" /><main id="main" data-id="element-213" data-mp="3dhjxucxkxrvq">{children}</main><SiteFooter data-id="element-214" data-mp="3did7blnxavhk" />
  </div>;
}